var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tamanho > 1)?_c('v-pagination',{attrs:{"light":"","length":_vm.tamanho,"total-visible":7,"disabled":_vm.carregando},model:{value:(_vm.atualizar),callback:function ($$v) {_vm.atualizar=$$v},expression:"atualizar"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }